import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

const reportId = "bo-natures";
const BosNatures = ({data, boName}) => {
  const reportName = `${boName} por natureza`

  useEffect(() => {
    const values = data.slice(0,5).map(i => i.qty);
    const labels = data.slice(0,5).map(i => i.reason);

    GraphicUtils.barChart(reportId, values, labels, false, true, 3);
    data && data.length > 0 && ReportUtils.createExportableTable(labels, values, reportName);

  }, [data]);

  return (
    <>
      <div className="chart-report">
        <span className="chart-title">{`${reportName} ${data?.length >= 5 ? ' (TOP 5)' : ''}`}</span>
        <div className="mt-3" id={reportId}></div>
      </div>

      <div className="chart-divisor"></div>
    </>
  );
};

export default BosNatures;